import { brandGroupConfigSelector } from '../redux/reducers/brandGroupConfigReducer';
import { store } from '../redux/store';
import { returnUrlPolicy, toAllowedReturnUrl } from './returnUrl';

export const hasAuthParams = (location = window.location): boolean => {
  // response_mode: query
  let searchParams = new URLSearchParams(location.search);
  if (searchParams.get('code') || searchParams.get('error')) {
    return true;
  }

  // response_mode: fragment
  searchParams = new URLSearchParams(location.hash.replace('#', '?'));
  return !!(searchParams.get('code') || searchParams.get('error'));
};

export const getSearchParamsWithoutAuthParams = (
  searchParams: URLSearchParams
): URLSearchParams => {
  // response_mode: query
  searchParams.delete('code');
  searchParams.delete('error');
  return searchParams;
};
export const toOrigin = (domain: string): string =>
  domain.startsWith('http') ? domain : `https://${domain}`;

export const authContinue = () => {
  const { fusionAuth, devReturnUrlDomains } = store.getState().apiConfig;

  // A FusionAuth flow is resumed through its flowId. Screens launched outside a hosted flow
  // carry a redirect_uri instead, so fall back to that.
  const flowId = window.auth.getFlowId();
  if (flowId) {
    window.location.href = `${toOrigin(fusionAuth.domain)}/flow/continue?flowId=${flowId}`;
    return;
  }

  const redirectUri = toAllowedReturnUrl(
    new URLSearchParams(window.location.search).get('redirect_uri'),
    returnUrlPolicy(brandGroupConfigSelector(store.getState()), devReturnUrlDomains)
  );
  if (redirectUri) {
    window.location.href = redirectUri;
    return;
  }

  console.error('authContinue: neither flowId nor redirect_uri');
};
